import {Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnDestroy, AfterViewInit} from '@angular/core';
import {ControlprocedureApiService} from '../../../../projects/api/src/controlprocedure/controlprocedure-api.service';

@Component({
    selector: 'app-dotted-border-tooltip',
    templateUrl: './dotted-border-tooltip.component.html',
    styleUrls: ['./dotted-border-tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DottedBorderTooltipComponent implements OnInit, OnDestroy, AfterViewInit  {


  text = '';

  @Input() showLabel = true;
  @Input() procId: any;
  @Input() bordersCache: null | [] = null;

  borders: any = {loading: true, data: []};
  isGeo = false;
  isFunc = false;

  constructor(private controlProcedureApiService: ControlprocedureApiService,
              private cdr: ChangeDetectorRef) {

  }


  ngOnInit() {
    if (this.procId) {
      this.getBorders();
    }
    this.cdr.detectChanges();
  }


  ngOnDestroy() {
    return;
  }

  ngAfterViewInit(): void {
    return;
  }

  getBorders() {
    const formatBorders = (borders) => {
      const result = [];
      borders.forEach(border => {
        if (border.type === 'FUNC') {
          this.isFunc = true;
        } else if (border.type === 'GEO') {
          this.isGeo = true;
        } else if (border.type === 'NUMERIC') {
          this.isGeo = false;
          border.intervals.forEach(interval => {
            result.push({
              from: interval.from,
              to: interval.to,
              state: border.state
            });
          });
        }
      });
      return result.sort((a, b) => {
        if (a.from === null) { return -1; }
        if (b.from === null) { return +1; }
        return a.from - b.from;
      });
    };

    if (this.bordersCache) {
      this.borders = {loading: false, data: formatBorders(this.bordersCache)};
      this.cdr.detectChanges();
      return;
    }

    this.borders = {loading: true, data: []};
    this.controlProcedureApiService.getProcedureBordersById(this.procId).subscribe(val => {
      this.borders = {loading: false, data: formatBorders(val)};
      this.cdr.detectChanges();
    });
  }
}
